export type BrandLogoVariant = 'icon' | 'horizontal' | 'vertical';

export const BRAND_NAME = 'Kyra';

export const BRAND_LOGOS: Record<BrandLogoVariant, string> = {
  icon: '/kyra-icon.svg',
  horizontal: '/kyra-horizontal.svg',
  vertical: '/kyra-logo.svg',
};

export const getBrandLogoPath = (variant: BrandLogoVariant = 'icon') => BRAND_LOGOS[variant];
